export default [
  {
    path: '/activity-20250825-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-09-07T23:59:59.000+08:00', title: '缘定七夕' },
  },
  {
    path: '/activity-20250825-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-09-07T23:59:59.000+08:00', title: '缘定七夕-规则说明' },
  },
  {
    path: '/activity-20250825-rule-2',
    component: () => import('./rule2.vue'),
    meta: { expire: '2025-09-07T23:59:59.000+08:00', title: '七夕告白夜-规则' },
  },
  {
    path: '/activity-20250825-publicity',
    component: () => import('./publicity.vue'),
    meta: { expire: '2025-09-07T23:59:59.000+08:00', title: '七夕告白夜' },
  },
]
